import { render, staticRenderFns } from "./VRChemLab.vue?vue&type=template&id=566d21d5"
import script from "./VRChemLab.vue?vue&type=script&lang=js"
export * from "./VRChemLab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports